import {isUndefined} from 'lodash';
import React, {FC, Key, ReactNode} from 'react';
import styled from 'styled-components';

import {IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {SuggestionSelectHandlerOptions} from '../../../../../../srcCommon/inboxes/search/searchSuggestionsHelpers';
import {buildVisualRecipientFromMatch} from '../../../../../helpers/models/recipientHelpers';
import {RecipientContactMatchModel} from '../../../../../models/api/recipientMatchModel';
import {RecipientRolesEnum} from '../../../../../models/api/recipientModel';
import {TeammateModel} from '../../../../../models/api/teammateModel';
import {ContactAvatar} from '../../../../common/avatars/contactAvatar';
import {TeammateAvatar} from '../../../../common/avatars/teammateAvatar';

/*
 * Props.
 */

export interface InboxesSearchSuggestionIconProps {
  icon?: ReactNode;
  iconName?: IconName;
  iconColor?: string;
}

export interface InboxesSearchSuggestionItemProps extends InboxesSearchSuggestionIconProps {
  key?: Key;
  label?: ReactNode;
  value: string;
  valuePlaceholder?: ReactNode;
  fuzzyQuery?: string;
  onSelectOptions?: SuggestionSelectHandlerOptions;
}

interface InboxesSuggestionsDropdownItemTeammateAvatarProps {
  teammate?: TeammateModel;
}

interface InboxesSuggestionsDropdownItemRecipientAvatarProps {
  recipient?: RecipientContactMatchModel;
}

/*
 * Styles.
 */

const StyledInboxesSuggestionsDropdownItemAvatar = styled.div`
  margin: 2px 8px 0 0;
`;

/*
 * Components.
 */

export const InboxesSuggestionsDropdownItemTeammateAvatar: FC<
  InboxesSuggestionsDropdownItemTeammateAvatarProps
> = ({teammate}) => {
  if (isUndefined(teammate)) {
    return null;
  }

  return (
    <StyledInboxesSuggestionsDropdownItemAvatar>
      <TeammateAvatar size={VisualSizesEnum.SMALL} teammate={teammate} />
    </StyledInboxesSuggestionsDropdownItemAvatar>
  );
};

export const InboxesSuggestionsDropdownItemRecipientAvatar: FC<
  InboxesSuggestionsDropdownItemRecipientAvatarProps
> = ({recipient}) => {
  if (isUndefined(recipient)) {
    return null;
  }

  const visualRecipient = buildVisualRecipientFromMatch('global', RecipientRolesEnum.FROM, recipient);
  return (
    <StyledInboxesSuggestionsDropdownItemAvatar>
      <ContactAvatar size={VisualSizesEnum.SMALL} visualContact={visualRecipient} />
    </StyledInboxesSuggestionsDropdownItemAvatar>
  );
};
